export const tabs = ()=> {
    const buttons = document.querySelectorAll('.product-hero__button')
    const images = document.querySelectorAll('.product-hero__item-image')
    const popSize = document.querySelector('.product-hero__pop-size-target')
    const capacityInput = document.querySelector('.product-hero__pop-form-wrapper input[name=capacity]')

    buttons?.forEach((btn,index)=> {
        if (btn.classList.contains('active')) {
            capacityInput.value = btn.textContent;
            popSize.innerHTML = btn.textContent
        }
        btn.addEventListener('click',()=> {
            const targetElement = document.querySelectorAll(`[data-target="${btn.getAttribute('data-id')}"]`)
            images?.forEach(image=> {
                image.classList.remove('active')
            })
            buttons?.forEach(btn=> {
                btn.classList.remove('active')
            })
            btn?.classList.add('active')
            capacityInput.value = btn.textContent;
            popSize.innerHTML = btn.textContent
            targetElement?.forEach(target=> {
                target?.classList.add('active')
            })
        })
    })
}